<div class="dashboard-container container-fluid px-0 d-flex flex-column min-vh-100">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <PropertySidebar
        v-if="sidebar_active_property"
        :active_property="sidebar_active_property"
        :properties="sidebar_tiles"
        :active_item="sidebar_active_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @switch-property="open_sidebar_property"
        @go-back="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
      />
      <PortfolioSidebar
        v-else
        :tiles="sidebar_tiles"
        @tile-clicked="open_sidebar_property"
        @global-menu-selected="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @global-selected="open_sidebar_portfolio"
      />
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay position-fixed d-flex align-items-stretch top-0 bottom-0 start-0 end-0" @click.self="mobile_sidebar_open = false">
      <div class="mobile-sidebar-panel h-100 overflow-hidden text-dark">
        <PropertySidebar
          v-if="sidebar_active_property"
          :active_property="sidebar_active_property"
          :properties="sidebar_tiles"
          :active_item="sidebar_active_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @switch-property="open_sidebar_property"
          @go-back="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-sm bg-white border text-dark" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PropertySidebar>
        <PortfolioSidebar
          v-else
          :tiles="sidebar_tiles"
          @tile-clicked="open_sidebar_property"
          @global-menu-selected="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @global-selected="open_sidebar_portfolio"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-sm bg-white border text-dark" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-sm border bg-white text-dark translate-middle-x" @click="sidebar_collapsed = !sidebar_collapsed">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-auto user-management-shell">
    <HeaderSection
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @open-assistant="show_assistant = true"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
    />

<div class="container-fluid p-0 settings-page user-management-page bg-light text-dark text-xs d-flex flex-column">
    <section class="container-fluid px-3 px-md-4 py-4">
        <SettingsUserManagementTab :user_profile="user_profile" />
    </section>

    <BolideAssistant :is_open="show_assistant" @close-assistant="show_assistant = false" />
</div>
    </div>
  </div>
</div>
